module.exports = __webpack_public_path__ + "media/country_flags/lc-1fc8484e.png";